import { type ReactNode, useEffect, useId, useState } from "react";

/** A GitLab style settings section: a large title, one line of description, and a body that can collapse. */
export function FormSection({ id, title, description, hash = "", children }: { id: string; title: string; description: string; hash?: string; children: ReactNode }) {
  const [open, setOpen] = useState(true);
  const body = useId();
  useEffect(() => {
    if (hash === `#${id}`) setOpen(true);
  }, [hash, id]);
  return (
    <section id={id} tabIndex={-1} className="form-section" data-open={open} aria-labelledby={`${body}-title`} data-testid={`section-${id}`}>
      <h2 className="form-section-title" id={`${body}-title`}>
        <button type="button" aria-expanded={open} aria-controls={body} onClick={() => setOpen(!open)} data-testid={`section-${id}-toggle`}>
          <svg className="form-section-chevron" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
            <path d="M6 3l5 5-5 5" fill="none" stroke="currentColor" strokeWidth="2" />
          </svg>
          {title}
        </button>
      </h2>
      <p className="form-section-desc">{description}</p>
      <div id={body} className="form-section-body" hidden={!open}>
        {children}
      </div>
    </section>
  );
}
